export default "__VITE_ASSET__CepceHTf__"